import { createSlice } from '@reduxjs/toolkit'

/**
 * Which entry point asked for the support options.
 *
 * It rides on the action rather than on <SupportModal>'s props because ten
 * screens render their own copy of that modal off this one flag — the instance
 * that ends up on screen says nothing about which button the user pressed.
 *
 * Analytics on every route but one: `bot_escalation` also hides the modal's
 * «پشتیبانی آنلاین» row, because that is the chat the escalation came out of.
 */
export type TSupportSource =
    | 'sidebar'
    | 'manager_record'
    | 'fund_detail'
    | 'bot_escalation'
    | 'unknown'

export interface ISideBar {
    isOpen: boolean
    isOpenSupportModal: boolean
    supportModalSource: TSupportSource
    isOpenLogoutModal: boolean
}
const initialState: ISideBar = {
    isOpen: false,
    isOpenSupportModal: false,
    supportModalSource: 'unknown',
    isOpenLogoutModal: false,
}
export const sideBarControler = createSlice({
    name: 'sideBarControler',
    initialState,
    reducers: {
        toggleSideBar: (state, action: { payload: { isOpen: boolean } }) => {
            state.isOpen = action.payload.isOpen
        },
        toggleSupportModal: (
            state,
            action: {
                payload: {
                    isOpenSupportModal: boolean
                    source?: TSupportSource
                }
            }
        ) => {
            state.isOpenSupportModal = action.payload.isOpenSupportModal
            if (action.payload.isOpenSupportModal) {
                state.supportModalSource = action.payload.source ?? 'unknown'
            }
        },
        toggleLogoutModal: (
            state,
            action: { payload: { isOpenLogoutModal: boolean } }
        ) => {
            state.isOpenLogoutModal = action.payload.isOpenLogoutModal
        },
    },
})

export const { toggleSideBar, toggleSupportModal, toggleLogoutModal } =
    sideBarControler.actions

export default sideBarControler.reducer
